import { isDspSource } from '../constants/orderSource'

/**
 * DBP orders resolve packlists via order-service reference number.
 * DSP orders use picking order_id (B2C reference format is rejected by order-service).
 */
export const buildPacklistApiUrl = ({ referenceNumber, orderId, source } = {}) => {
  if (isDspSource(source) && orderId !== undefined && orderId !== null && orderId !== '') {
    return `/picking-service/v3/packlists?deliveryOrderId=${encodeURIComponent(
      String(orderId)
    )}`
  }

  return `/picking-service/v3/packlists?deliveryOrderReferenceNumber=${encodeURIComponent(
    referenceNumber
  )}`
}

export default buildPacklistApiUrl
